import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const TrainingUntypedQualificationsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training--untyped-qualifications']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
